module.exports = __webpack_public_path__ + "static/media/sfulogo.aa96f48c.jpg";